export enum EntityType {
  Organization = 'organization',
  Case = 'case',
}
